{
  "backToLogin": "Zurück zur Anmeldung",
  "confirmPassword": "Passwort wiederholen",
  "displayName": "Ihr Name",
  "email": "E-Mail",
  "password": "Passwort",
  "passwordMismatch": "Die Passwörter stimmen nicht überein."
}
